(function(app) {

    app.directive("file",
    [
        function() {
            return {
                restrict: "A",
                require: "?ngModel",
                link: function($scope, element, attrs, ngModel) {
                    var handler = function(e) {
                        $scope.$apply(function () {
                            ngModel.$setViewValue(e.target.files[0]);
                        });
                    };

                    element[0].addEventListener("change", handler, false);
                }
            };
        }
    ]);

})(window.app); //jshint ignore:line